export default __webpack_public_path__ + "static/media/buy-bg.170309f6.jpg";